module.exports = __webpack_public_path__ + "static/img/068_TO8_1693_og.8f4012e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/068_TO8_1693_og.jpg
// module id = nFtM
// module chunks = 0